import { Box, Button, Grid, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import CustomText, { textStyles } from "../../components/CustomText";
import { useMediaQuery, } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import more from "../../assets/more.svg";
import GetAppButton from "../../components/GetAppButton";
import FeaturesHeroCard from "../../components/cards/FeaturesHeroCard";

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import hero4estime from "../../assets/spanish/TimeTracking/hero4estime.webp";
import herocard4time from "../../assets/TimeTracking/herocard4time.webp";
import hero1es from "../../assets/spanish/Communication/hero1es.webp";
import hero2es from "../../assets/spanish/Communication/hero2es.webp";
import hero3es from "../../assets/spanish/Communication/hero3es.webp";
import hero4es from "../../assets/spanish/Communication/hero4es.webp";
import hero5es from "../../assets/spanish/Communication/hero5es.webp"
import heroimage from "../../assets/communication/heroimage.webp";
import herocard1 from "../../assets/communication/herocard1.webp";
import herocard2 from "../../assets/communication/herocard2.webp";
import herocard3 from "../../assets/communication/herocard3.webp";
import herocard4 from "../../assets/communication/herocard4.webp";
import herocard5 from "../../assets/doc_eng.png"; // Adjust the path as necessary
import herocard6 from "../../assets/doc_spa.png"; // Adjust the path as necessary
import { useState } from "react";
import { Skeleton } from "@mui/material";
import { BASE_URL } from "../../components/BASE_URL";
import { useSocialLinks } from "../../components/fetchGetAppUrl";
import FeaturesBigHeroCard from "../../components/cards/FeaturesBigHeroCard";
const HeroSection = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"))
  const hero_section_button_text = {
    main: "var(--Tertiary, #003149)",
    hover: "#00263a",
    contrastText: "#FFFFFF",
    fontSize: "18px",
  }
  const location = useLocation();

  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      // Give time for DOM/rendering/layout/styles to finish
      setTimeout(() => {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 300); // Adjust timeout if needed
    }
  }, []);

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  const navigate = useNavigate()
  const handleMore = () => {
    navigate("/product-tour")
  }
  const heroImageSrc = i18n.language === "es" ? hero1es : heroimage;
  const card1 = i18n.language === "es" ? hero2es : herocard1;
  const card2 = i18n.language === "es" ? hero3es : herocard2;
  const card3 = i18n.language === "es" ? hero4es : herocard3;
  const card4 = i18n.language === "es" ? hero5es : herocard4;
  //  const Card3 = i18n.language === "es" ? hero4es : herocard4;
  const Card3 = i18n.language === "es" ? hero4estime : herocard4time;
  const Card5 = i18n.language === "es" ? herocard6 : herocard5;

  const parseFeatureNames = (list) => {
    try {
      const items = Array.isArray(list)
        ? list
        : list
          ? JSON.parse(list)
          : [];
      return items.map((f) => f.name);
    } catch {
      return [];
    }
  };

  const [commHeroData, setCommHeroData] = useState(null);
const [commHeroLoading, setCommHeroLoading] = useState(true);

useEffect(() => {
  const fetchCommHeroData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Centralized_Communication`
      );
      const data = await res.json();

      if (!data.error && data.data?.length > 0) {
        const section = data.data[0];

        // 🔑 Pick based on language
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        if (item) {
          setCommHeroData({
            title: item.title,
            description: item.description,
          });
        }
      }
    } catch (err) {
      console.error("Error fetching Communication Hero:", err);
    } finally {
      setCommHeroLoading(false);
    }
  };

  fetchCommHeroData();
}, [i18n.language]);


const [msgData, setMsgData] = useState(null);
const [msgLoading, setMsgLoading] = useState(true);

useEffect(() => {
  const fetchMessagingData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Messaging_Conversations`
      );
      const data = await res.json();

      if (!data.error && data.data?.length > 0) {
        const section = data.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        const parsedList = parseFeatureNames(item?.list);

        setMsgData({
          title: item?.title || "",
          description: item?.description || "",
          features: parsedList,
        });
      }
    } catch (err) {
      console.error("Error fetching Messaging_Conversations:", err);
    } finally {
      setMsgLoading(false);
    }
  };

  fetchMessagingData();
}, [i18n.language]);




const [notifData, setNotifData] = useState(null);
const [notifLoading, setNotifLoading] = useState(true);

useEffect(() => {
  const fetchNotifData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Smart_Notifications`
      );
      const data = await res.json();

      if (!data.error && data.data?.length > 0) {
        const section = data.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        const parsedList = parseFeatureNames(item?.list);

        setNotifData({
          title: item?.title || "",
          description: item?.description || "",
          features: parsedList,
        });
      }
    } catch (err) {
      console.error("Error fetching Smart_Notifications:", err);
    } finally {
      setNotifLoading(false);
    }
  };

  fetchNotifData();
}, [i18n.language]);




const [requestData, setRequestData] = useState(null);
const [requestLoading, setRequestLoading] = useState(true);

useEffect(() => {
  const fetchRequestData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Request_Generation`
      );
      const data = await res.json();

      if (!data.error && data.data?.length > 0) {
        const section = data.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        const parsedList = parseFeatureNames(item?.list);

        setRequestData({
          title: item?.title || "",
          description: item?.description || "",
          features: parsedList,
        });
      }
    } catch (err) {
      console.error("Error fetching Request_Generation:", err);
    } finally {
      setRequestLoading(false);
    }
  };

  fetchRequestData();
}, [i18n.language]);



const [adminReviewData, setAdminReviewData] = useState(null);
const [adminReviewLoading, setAdminReviewLoading] = useState(true);

// ✅ Admin Review
useEffect(() => {
  const fetchAdminReviewData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Admin_Review`
      );
      const data = await res.json();

      if (!data.error && data.data?.length > 0) {
        const section = data.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        const parsedList = parseFeatureNames(item?.list);

        setAdminReviewData({
          title: item?.title || "",
          description: item?.description || "",
          features: parsedList,
        });
      }
    } catch (err) {
      console.error("Error fetching Admin_Review:", err);
    } finally {
      setAdminReviewLoading(false);
    }
  };

  fetchAdminReviewData();
}, [i18n.language]);


const [docData, setDocData] = useState(null);
const [docLoading, setDocLoading] = useState(true);

useEffect(() => {
  const fetchDocData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Document`
      );
      const data = await res.json();

      if (!data.error && data.data?.length > 0) {
        const section = data.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        const parsedList = parseFeatureNames(item?.list);

        setDocData({
          title: item?.title || "",
          description: item?.description || "",
          features: parsedList,
        });
      }
    } catch (err) {
      console.error("Error fetching Documents:", err);
    } finally {
      setDocLoading(false);
    }
  };

  fetchDocData();
}, [i18n.language]);
  const { links } = useSocialLinks();


  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-between",
          alignItems: "center",
          px: isMobile ? 2 : 8,
          py: 6,
          backgroundColor: "#fff",
          gap: 4,
          marginTop: '70px'
        }}
      >
        <Box
          sx={{
            flex: 1,
            textAlign: { xs: "center", md: "left" },

          }}
        >
          {/* <CustomText
            style={{
              ...textStyles.h1,
              marginBottom: isMobile ? "0rem" : "1rem",
              marginTop: isMobile ? "0rem" : "1rem",
              fontSize: isMobile ? "36px" : "50px",
              textAlign: isMobile ? "center" : "left",

              // maxWidth:"400px"
            }}
          >
            {t("comm_hero_title")}

          </CustomText>

          <CustomText
            style={{
              ...textStyles.body1,
              color: "#868282",
              //  maxWidth: "1175px",
              margin: "0 auto",
              marginTop: "10px",
              textAlign: isMobile ? "center" : "left",

            }}
          >
            {t("comm_hero_subtitle")}
          </CustomText> */}
          {commHeroLoading ? (
  <Skeleton variant="text" width={300} height={60} />
) : (
  <CustomText
    style={{
      ...textStyles.h1,
      marginBottom: isMobile ? "0rem" : "1rem",
      marginTop: isMobile ? "0rem" : "1rem",
      fontSize: isMobile ? "36px" : "50px",
      textAlign: isMobile ? "center" : "left",
    }}
  >
    {commHeroData?.title}
  </CustomText>
)}

{commHeroLoading ? (
  <Skeleton variant="text" width={500} height={40} />
) : (
  <CustomText
    style={{
      ...textStyles.body1,
      color: "#868282",
      margin: "0 auto",
      marginTop: "10px",
      textAlign: isMobile ? "center" : "left",
    }}
  >
    {commHeroData?.description}
  </CustomText>
)}
          <Box
            sx={{
              display: "flex",
              flexWrap: isMobile ? "wrap" : "nowrap",
              justifyContent: isMobile ? "center" : "flex-start",
              alignItems: "center",
              mt: isMobile ? "10px" : 4,
              gap: 1,
            }}
          >
            <GetAppButton
              label={t("get_app_now")}
              variant="primary" size="large" />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 0,
                cursor: "pointer",
              }}
              onClick={handleMore}
            >
              <img src={more || "/placeholder.svg"} style={{ width: "65px", height: "65px" }} />
              <p
                style={{
                  color: hero_section_button_text.main,
                  fontSize: "18px",
                  fontWeight: 600,
                  fontFamily: "Poppins, sans-serif",
                  cursor: "pointer",
                }}
              >
                {t("Learn More")}
              </p>
            </Box>
          </Box>
        </Box>

        {/* Right Section - Image */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: { xs: 4, md: 0 },
          }}
        >
          <Box
            component="img"
            src={heroImageSrc}
            alt="Dashboard Preview"
            sx={{
              width: "100%",
              maxWidth: "550px",
              height: "auto",
            }}
          />
        </Box>
      </Box>
      <Box>
   
        <Box
  id="realtime-messaging"
  sx={{
    scrollMarginTop: "80px",
  }}
>
  {msgLoading ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={500} height={30} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={150}
        sx={{ mt: 2 }}
      />
    </Box>
  ) : (
    <FeaturesHeroCard
      bgColor="#EFF4F8"
      image={card1}
      imagePosition="left"
      title={msgData?.title}
      description={msgData?.description}
      features={msgData?.features}
    />
  )}
</Box>
  

        <Box
  id="communication-history"
  sx={{
    scrollMarginTop: "80px",
  }}
>
  {notifLoading ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={500} height={30} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={150}
        sx={{ mt: 2 }}
      />
    </Box>
  ) : (
    <FeaturesBigHeroCard
      bgColor="#FFFFFF"
      image={card2}
      imagePosition="right"
      title={notifData?.title}
      description={notifData?.description}
      features={notifData?.features}
    />
  )}
</Box>


  

        <Box id="smart-requests">
  {requestLoading ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={500} height={30} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={150}
        sx={{ mt: 2 }}
      />
    </Box>
  ) : (
    <FeaturesHeroCard
      bgColor="#EFF4F8"
      image={card3}
      imagePosition="left"
      title={requestData?.title}
      description={requestData?.description}
      features={requestData?.features}
    />
  )}
</Box>



   

<Box id="expense-claims">
  {adminReviewLoading ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={500} height={30} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={150}
        sx={{ mt: 2 }}
      />
    </Box>
  ) : (
    <FeaturesHeroCard
      bgColor="#FFFFFF"
      image={card4}
      imagePosition="right"
      title={adminReviewData?.title}
      description={adminReviewData?.description}
      features={adminReviewData?.features}
    />
  )}
</Box>


<Box id="real-time-insight-card">
  {docLoading ? (
    <Box sx={{ p: 3 }}>
      <Skeleton variant="text" width={250} height={40} />
      <Skeleton variant="text" width={500} height={30} />
      <Skeleton
        variant="rectangular"
        width="100%"
        height={150}
        sx={{ mt: 2 }}
      />
    </Box>
  ) : (
    <FeaturesHeroCard
      bgColor="#EFF4F8"
      image={Card5}
      imagePosition="left"
      title={docData?.title}
      description={docData?.description}
      features={docData?.features}
    />
  )}
</Box>
  


      </Box>
    </>
  );
}
export default HeroSection
